import { EPermissionGroup, IPermissions } from 'common/permissions.types';
import { EFeatureFlag, StoreBodyBlock } from 'constants/enums';
import { permissionsUtil } from 'utils/permissionsUtil';

import { ESettingsState } from './Settings.types';

const getActiveSettingsTab = (
  permissions: IPermissions | undefined,
  id: string | undefined,
  isCheckoutProject: boolean | undefined,
  isDeveloperSettingsEnabled = false
): ESettingsState | undefined => {
  if (
    !permissionsUtil.shouldHideGroupInPermission(
      permissions,
      EPermissionGroup.AUTHENTICATION,
      id
    ) &&
    !isCheckoutProject
  ) {
    return ESettingsState.PLAYER_AUTH;
  }

  if (
    !permissionsUtil.shouldHideGroupInPermission(
      permissions,
      EPermissionGroup.USERS,
      id
    )
  ) {
    return ESettingsState.USERS;
  }

  const hasCompanyPermission = !permissionsUtil.shouldHideGroupInPermission(
    permissions,
    EPermissionGroup.COMPANY,
    id
  );

  const hasIntegrationPermission = !permissionsUtil.shouldHideGroupInPermission(
    permissions,
    EPermissionGroup.INTEGRATION,
    id
  );

  if (isDeveloperSettingsEnabled && (hasCompanyPermission || hasIntegrationPermission)) {
    return ESettingsState.DEVELOPER_SETTINGS;
  }

  if (hasCompanyPermission) {
    return ESettingsState.COMPANY;
  }

  if (hasIntegrationPermission) {
    return ESettingsState.INTEGRATION;
  }
};

export const settingsTabUtils = {
  getActiveSettingsTab
};

const mapBodyBlockToDisplayName: Record<StoreBodyBlock, string> = {
  [StoreBodyBlock.dailyBonusBadge]: 'Daily Bonus Badge',
  [StoreBodyBlock.playerLevel]: 'Player Level',
  [StoreBodyBlock.banners]: 'Banner',
  [StoreBodyBlock.progressBars]: 'Progress Bars',
  [StoreBodyBlock.specialOffers]: 'Promotions',
  [StoreBodyBlock.rollingOffers]: 'Rolling Offers',
  [StoreBodyBlock.bundles]: 'Bundles',
  [StoreBodyBlock.richText]: 'Rich Text'
};

export const filterBodyBlocksByFeatureFlags =
  (featureFlags: Record<string, boolean>) => (item: StoreBodyBlock) =>
    (item !== StoreBodyBlock.playerLevel ||
      featureFlags[EFeatureFlag.DASHBOARD_BODYBLOCK_SUPPORT_PLAYER_LEVEL]) &&
    (item !== StoreBodyBlock.progressBars ||
      featureFlags[EFeatureFlag.DASHBOARD_PROGRESS_BAR]) &&
    item !== StoreBodyBlock.rollingOffers;

export const mapBodyBlocksToListItems =
  (currentFormValue: StoreBodyBlock[]) => (block: StoreBodyBlock) => ({
    value: block,
    name: mapBodyBlockToDisplayName[block],
    enabled: currentFormValue.includes(block)
  });
